import React from 'react';
import MiniProductCard from '_components/ProductStrip/MiniProductCard';
import type { AlgonomyOutfit } from '@components/global/Recommendations/outfits';
import styles from './OutfitCard.module.scss';

export interface OutfitCardProps {
  outfit: AlgonomyOutfit;
}

const OutfitCard = ({ outfit }: OutfitCardProps) => {
  if (!outfit.items.length) return null;

  return (
    <div className={styles.card}>
      <ul className={styles.list}>
        {outfit.items.slice(0, 3).map((product, i) => (
          <li key={product.id} className={styles.item}>
            <MiniProductCard
              displayName={product.displayName}
              displayPrice={product.displayPrice}
              displaySalePrice={product.displaySalePrice || undefined}
              imageURL={product.imageURL}
              href={product.linkURL ?? product.detailURL}
              withBorder={false}
              priority={i < 3}
              withBoxShadow={false}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default OutfitCard;
